import React, { Component } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash.debounce';
import classNames from 'classnames';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import { translate } from 'services/i18nService';

import styles from './Input.css';


const DEBOUNCE_DELAY = 150;
const MAX_WAIT = 200;

export default class Input extends Component {
  static propTypes = {
    customWrapperClass: PropTypes.string,
    disabled: PropTypes.bool,
    errorText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    hint: PropTypes.string,
    inputClass: PropTypes.string,
    inputLength: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    inputMargin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    prefix: PropTypes.string,
    required: PropTypes.bool,
    showSuccessMessage: PropTypes.bool,
    type: PropTypes.string,
    valid: PropTypes.bool,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    customWrapperClass: undefined,
    disabled: false,
    errorText: 'This field is required',
    hint: '',
    inputClass: undefined,
    inputLength: undefined,
    inputMargin: undefined,
    label: undefined,
    prefix: undefined,
    required: true,
    showSuccessMessage: false,
    type: 'text',
    valid: true,
    onChange: () => undefined,
  };

  state = {
    showPassword: false,
  };

  onDebounceChange = debounce(this.props.onChange, DEBOUNCE_DELAY, { maxWait: MAX_WAIT });

  onVisibilityClick = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  render() {
    const {
      customWrapperClass,
      disabled,
      errorText,
      hint,
      inputClass,
      inputLength,
      inputMargin,
      label,
      prefix,
      required,
      showSuccessMessage,
      type,
      valid,
      ...rest
    } = this.props;
    const { showPassword } = this.state;

    const BOTTOM_MARGIN = '0 0 30px 0';
    const NO_MARGIN = '0';

    let margin = NO_MARGIN;
    if (inputMargin) {
      margin = inputMargin;
    } else if (label) {
      margin = BOTTOM_MARGIN;
    }

    const isPrefixed = prefix && prefix.length > 0;
    const inputClasses = classNames({
      'inputField': true,
      [styles.input]: true,
      [inputClass]: true,
      [styles.inputPadding]: isPrefixed,
    });
    const groupClasses = classNames(styles.group, customWrapperClass, { [styles.invalid]: !valid });

    let passwordVisibilityToggle = null;
    if (type === 'password') {
      passwordVisibilityToggle = (
        <IconButton
          aria-label="Toggle password visibility"
          className={styles.visibilityToggleButton}
          size="small"
          title={translate('strings.show.password')}
          onClick={this.onVisibilityClick}
        >
          {showPassword ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      );
    }

    return (
      <div className={groupClasses} style={{ width: inputLength, margin }}>
        <input
          className={inputClasses}
          disabled={disabled}
          required={required}
          type={showPassword ? 'text' : type}
          onChange={this.onDebounceChange}
          {...rest}
        />

        {passwordVisibilityToggle}

        {isPrefixed && <span className={styles.prefix}>{prefix}</span>}

        {hint && (
          <label className={styles.hint} htmlFor={this.id}>
            {hint}
          </label>
        )}
        {label && (
          <label className={styles.label} htmlFor={this.id}>
            {label}
          </label>
        )}
        <i className={styles.bar} />
        {!valid && <div className={styles.errorText}>{errorText}</div>}
        {showSuccessMessage && valid && <div className={styles.successText}>{errorText}</div>}
      </div>
    );
  }
}
